module.exports = __webpack_public_path__ + "static/future-of-work-the-rise-of-nomadic-work-3502468d62c1151988670f2011ed1903.png";